export const UPLOAD_DB_NAME = "streamline-upload-transfer";

export const UPLOAD_DB_VERSION = 1;

export const UPLOAD_STORES = {
  jobs: "uploadJobs",
  sources: "uploadSources",
  schemaMeta: "schemaMeta"
};

export const UPLOAD_INDEXES = {
  [UPLOAD_STORES.jobs]: [
    { name: "status", keyPath: "status" },
    { name: "updatedAt", keyPath: "updatedAt" },
    { name: "createdAt", keyPath: "createdAt" },
    { name: "accountId", keyPath: "accountId" }
  ],
  [UPLOAD_STORES.sources]: [
    { name: "jobId", keyPath: "jobId" },
    { name: "status", keyPath: "status" },
    { name: "jobId_status", keyPath: ["jobId", "status"] }
  ],
  [UPLOAD_STORES.schemaMeta]: []
};
